import axios from "axios";

export const BASE_ROUTE = "medical_fees";

export let getAllMedicalFees = function (caseId) {
  return axios.get(`${BASE_ROUTE}/${caseId}`);
}

export let saveMedicalFee = function (data) {
  return axios.post(`${BASE_ROUTE}`, data);
}

export let updateMedicalFee = function (data, id) {
  return axios.put(`${BASE_ROUTE}/${id}`, data);
}

export let getAllStatusesCategory = function () {
  return axios.get(`${BASE_ROUTE}/getStatusesCategory`);
}

export let getAllCategorizations = function () {
  return axios.get(`${BASE_ROUTE}/getCategorizations`);
}

export let getAllSpecialities = function () {
  return axios.get(`${BASE_ROUTE}/getSpecialities`);
}

export let getAllProcessesTab = function () {
  return axios.get(`${BASE_ROUTE}/getProcessesTab`);
}